// Mock data for Blue Harbor Labs Operator Console (Phase 0 visual prototype)
// NO real data, NO DB writes, NO production behavior.

export const MOCK_ADMIN_USER = {
  id: "u_rafael",
  name: "Rafael Soto",
  email: "rafael@blueharborlabs.com",
  role: "admin", // simulates existing ShelfLife admin role gate
  org: "Blue Harbor Labs",
};

export const MOCK_CLIENTS = [
  {
    id: "co_uncle_giuseppe",
    name: "Uncle Giuseppe's Marketplace",
    status: "active",
    storeCount: 7,
    userCount: 142,
    catalogStatus: "synced",
    catalogItems: 18420,
    billingStatus: "trial",
    billingDays: 14,
    plan: "Growth",
    renewal: "2026-04-15",
    paymentMethod: "Not connected",
    lastActivity: "2 hours ago",
    createdAt: "2025-11-04",
    headquarters: "Long Island, NY",
    accountOwner: "Rafael Soto",
    notes: "Pilot rollout completed at 3 of 7 stores. Expanding chain-wide.",
    stores: [
      { id: "s_1", name: "Uncle Giuseppe's — Smithtown", address: "2330 Nesconset Hwy, Stony Brook, NY", departments: 14, users: 28, status: "active" },
      { id: "s_2", name: "Uncle Giuseppe's — Port Washington", address: "111 Channel Dr, Port Washington, NY", departments: 14, users: 24, status: "active" },
      { id: "s_3", name: "Uncle Giuseppe's — East Meadow", address: "1108 Hempstead Tpke, East Meadow, NY", departments: 13, users: 22, status: "active" },
      { id: "s_4", name: "Uncle Giuseppe's — Melville", address: "880 Walt Whitman Rd, Melville, NY", departments: 14, users: 26, status: "onboarding" },
      { id: "s_5", name: "Uncle Giuseppe's — Ramsey", address: "1108 Route 17 N, Ramsey, NJ", departments: 13, users: 18, status: "onboarding" },
      { id: "s_6", name: "Uncle Giuseppe's — Morris Plains", address: "3056 Route 10 W, Morris Plains, NJ", departments: 14, users: 14, status: "pending" },
      { id: "s_7", name: "Uncle Giuseppe's — North Caldwell", address: "289 Bloomfield Ave, Caldwell, NJ", departments: 13, users: 10, status: "pending" },
    ],
    departments: [
      "Produce", "Bakery", "Deli", "Meat", "Seafood", "Dairy",
      "Frozen", "Grocery", "Prepared Foods", "Cheese", "Wine & Beer",
      "Floral", "Catering", "Front End",
    ],
    users: [
      { id: "u_1", name: "Anna DiLeo", email: "anna@unclegs.com", role: "Store Manager", store: "Smithtown", status: "active" },
      { id: "u_2", name: "Marco Russo", email: "marco@unclegs.com", role: "Department Lead", store: "Smithtown", status: "active" },
      { id: "u_3", name: "Priya Patel", email: "priya@unclegs.com", role: "Store Manager", store: "Port Washington", status: "active" },
      { id: "u_4", name: "Jordan Lee", email: "jordan@unclegs.com", role: "Receiver", store: "East Meadow", status: "active" },
      { id: "u_5", name: "Sam Cohen", email: "sam@unclegs.com", role: "Store Manager", store: "Melville", status: "invited" },
    ],
  },
  {
    id: "co_example_market",
    name: "Example Market",
    status: "onboarding",
    storeCount: 2,
    userCount: 18,
    catalogStatus: "review",
    catalogItems: 4120,
    billingStatus: "trial",
    billingDays: 21,
    plan: "Starter",
    renewal: "2026-04-28",
    paymentMethod: "Not connected",
    lastActivity: "27 minutes ago",
    createdAt: "2026-01-08",
    headquarters: "Austin, TX",
    accountOwner: "Rafael Soto",
    notes: "Catalog imported, awaiting department mapping review.",
    stores: [
      { id: "es_1", name: "Example Market — South Lamar", address: "2438 W Anderson Ln, Austin, TX", departments: 10, users: 11, status: "onboarding" },
      { id: "es_2", name: "Example Market — Mueller", address: "1801 E 51st St, Austin, TX", departments: 9, users: 7, status: "onboarding" },
    ],
    departments: [
      "Produce", "Bakery", "Deli", "Meat", "Dairy",
      "Frozen", "Grocery", "Beverages", "Health & Wellness", "Front End",
    ],
    users: [
      { id: "eu_1", name: "Drew Whitman", email: "drew@examplemarket.com", role: "Owner", store: "South Lamar", status: "active" },
      { id: "eu_2", name: "Tasha Ng", email: "tasha@examplemarket.com", role: "Store Manager", store: "Mueller", status: "active" },
      { id: "eu_3", name: "Lupe Vega", email: "lupe@examplemarket.com", role: "Department Lead", store: "South Lamar", status: "invited" },
    ],
  },
  {
    id: "co_demo_grocery",
    name: "Demo Grocery",
    status: "pending",
    storeCount: 1,
    userCount: 3,
    catalogStatus: "not_started",
    catalogItems: 0,
    billingStatus: "not_set",
    billingDays: 30,
    plan: "Starter",
    renewal: "—",
    paymentMethod: "Not connected",
    lastActivity: "Yesterday",
    createdAt: "2026-01-11",
    headquarters: "Brooklyn, NY",
    accountOwner: "Rafael Soto",
    notes: "Sandbox tenant for sales demos and prospect walkthroughs.",
    stores: [
      { id: "ds_1", name: "Demo Grocery — Flagship", address: "123 Mock Street, Brooklyn, NY", departments: 6, users: 3, status: "pending" },
    ],
    departments: ["Produce", "Bakery", "Deli", "Dairy", "Grocery", "Front End"],
    users: [
      { id: "du_1", name: "Demo Admin", email: "admin@demogrocery.test", role: "Owner", store: "Flagship", status: "active" },
      { id: "du_2", name: "Demo Manager", email: "manager@demogrocery.test", role: "Store Manager", store: "Flagship", status: "active" },
      { id: "du_3", name: "Demo Lead", email: "lead@demogrocery.test", role: "Department Lead", store: "Flagship", status: "invited" },
    ],
  },
];

// Onboarding checklist per client. Per spec — Add Payment Method is the only unchecked step.
export const ONBOARDING_STEPS = (clientId) => {
  const base = [
    { key: "create_company", label: "Create company", done: true },
    { key: "add_stores", label: "Add stores", done: true },
    { key: "add_departments", label: "Add departments", done: true },
    { key: "import_catalog", label: "Import catalog", done: true },
    { key: "review_catalog", label: "Review catalog", done: true },
    { key: "create_users", label: "Create users", done: true },
    { key: "activate_client", label: "Activate client", done: true },
    { key: "add_payment_method", label: "Add payment method", done: false },
  ];
  if (clientId === "co_example_market") {
    base[4].done = false; // review catalog still pending
    base[6].done = false; // not activated yet
  }
  if (clientId === "co_demo_grocery") {
    return [
      { key: "create_company", label: "Create company", done: true },
      { key: "add_stores", label: "Add stores", done: true },
      { key: "add_departments", label: "Add departments", done: false },
      { key: "import_catalog", label: "Import catalog", done: false },
      { key: "review_catalog", label: "Review catalog", done: false },
      { key: "create_users", label: "Create users", done: false },
      { key: "activate_client", label: "Activate client", done: false },
      { key: "add_payment_method", label: "Add payment method", done: false },
    ];
  }
  return base;
};

// Catalog onboarding mock state per client
export const CATALOG_ONBOARDING = {
  co_uncle_giuseppe: {
    file: { name: "uncle_giuseppes_master_catalog_v4.csv", type: "CSV", size: "8.7 MB", uploadedAt: "2025-12-19 14:22 EST" },
    mapping: { status: "complete", percent: 100, mappedColumns: 14, totalColumns: 14 },
    departmentMappings: [
      { source: "PROD", target: "Produce", items: 1820, status: "mapped" },
      { source: "BAKE", target: "Bakery", items: 940, status: "mapped" },
      { source: "DELI", target: "Deli", items: 1310, status: "mapped" },
      { source: "MEAT", target: "Meat", items: 1620, status: "mapped" },
      { source: "SEAF", target: "Seafood", items: 410, status: "mapped" },
      { source: "DAIR", target: "Dairy", items: 1240, status: "mapped" },
      { source: "FRZ", target: "Frozen", items: 1880, status: "mapped" },
      { source: "GRCY", target: "Grocery", items: 6740, status: "mapped" },
      { source: "PREP", target: "Prepared Foods", items: 720, status: "mapped" },
      { source: "CHZ", target: "Cheese", items: 360, status: "mapped" },
      { source: "WINE", target: "Wine & Beer", items: 1180, status: "mapped" },
      { source: "FLR", target: "Floral", items: 110, status: "mapped" },
      { source: "CAT", target: "Catering", items: 60, status: "mapped" },
      { source: "FE", target: "Front End", items: 30, status: "mapped" },
    ],
    rowsTotal: 18420,
    approvedRows: 18116,
    rejectedRows: 304,
    warnings: [
      { code: "MISSING_UPC", message: "12 rows missing UPC — auto-flagged for review", count: 12 },
      { code: "DUPLICATE_SKU", message: "47 duplicate SKUs detected and de-duplicated", count: 47 },
      { code: "PRICE_OUT_OF_RANGE", message: "8 items with price > $999.99 (verify with client)", count: 8 },
      { code: "MISSING_DEPARTMENT", message: "237 rows with unknown department code — defaulted to Grocery", count: 237 },
    ],
  },
  co_example_market: {
    file: { name: "example_market_pos_export.xlsx", type: "Excel", size: "1.4 MB", uploadedAt: "2026-01-10 09:48 CST" },
    mapping: { status: "in_review", percent: 78, mappedColumns: 11, totalColumns: 14 },
    departmentMappings: [
      { source: "PR", target: "Produce", items: 480, status: "mapped" },
      { source: "BK", target: "Bakery", items: 210, status: "mapped" },
      { source: "DL", target: "Deli", items: 290, status: "mapped" },
      { source: "MT", target: "Meat", items: 360, status: "mapped" },
      { source: "DA", target: "Dairy", items: 280, status: "mapped" },
      { source: "FZ", target: "Frozen", items: 540, status: "mapped" },
      { source: "GR", target: "Grocery", items: 1680, status: "mapped" },
      { source: "BV", target: "Beverages", items: 290, status: "mapped" },
      { source: "HW", target: "Health & Wellness", items: 140, status: "mapped" },
      { source: "FE", target: "Front End", items: 50, status: "mapped" },
      { source: "MISC", target: "—", items: 132, status: "unmapped" },
    ],
    rowsTotal: 4120,
    approvedRows: 3782,
    rejectedRows: 206,
    warnings: [
      { code: "UNMAPPED_DEPARTMENT", message: "132 rows under code 'MISC' — needs operator review", count: 132 },
      { code: "MISSING_COST", message: "74 items missing wholesale cost", count: 74 },
      { code: "INVALID_TAX_CODE", message: "18 items with invalid tax classification", count: 18 },
    ],
  },
  co_demo_grocery: {
    file: null,
    mapping: { status: "not_started", percent: 0, mappedColumns: 0, totalColumns: 0 },
    departmentMappings: [],
    rowsTotal: 0,
    approvedRows: 0,
    rejectedRows: 0,
    warnings: [],
  },
};

export const BILLING_PLACEHOLDER = {
  co_uncle_giuseppe: {
    subscriptionStatus: "Trial — 14 days remaining",
    plan: "Growth (up to 10 stores)",
    renewalDate: "2026-04-15",
    paymentMethod: "Not connected (placeholder)",
    monthlyEstimate: "$2,940.00",
    seats: "142 / 200",
  },
  co_example_market: {
    subscriptionStatus: "Trial — 21 days remaining",
    plan: "Starter (up to 3 stores)",
    renewalDate: "2026-04-28",
    paymentMethod: "Not connected (placeholder)",
    monthlyEstimate: "$640.00",
    seats: "18 / 30",
  },
  co_demo_grocery: {
    subscriptionStatus: "Not provisioned",
    plan: "—",
    renewalDate: "—",
    paymentMethod: "Not connected (placeholder)",
    monthlyEstimate: "—",
    seats: "3 / 5",
  },
};

export const OPERATOR_ACTIVITY = [
  { id: "a1", type: "company_created", actor: "Rafael Soto", target: "Demo Grocery", time: "Yesterday, 4:12 PM", description: "Created company tenant for sales demo use" },
  { id: "a2", type: "catalog_imported", actor: "Rafael Soto", target: "Example Market", time: "2 days ago, 9:48 AM", description: "Imported example_market_pos_export.xlsx (4,120 rows)" },
  { id: "a3", type: "user_created", actor: "Rafael Soto", target: "Example Market", time: "2 days ago, 10:11 AM", description: "Invited Drew Whitman as Owner" },
  { id: "a4", type: "store_added", actor: "Rafael Soto", target: "Uncle Giuseppe's Marketplace", time: "5 days ago, 11:30 AM", description: "Added Morris Plains and North Caldwell locations" },
  { id: "a5", type: "catalog_imported", actor: "Rafael Soto", target: "Uncle Giuseppe's Marketplace", time: "3 weeks ago, 2:22 PM", description: "Imported uncle_giuseppes_master_catalog_v4.csv (18,420 rows)" },
  { id: "a6", type: "user_created", actor: "Rafael Soto", target: "Uncle Giuseppe's Marketplace", time: "3 weeks ago, 2:35 PM", description: "Bulk-invited 142 staff users across 5 stores" },
  { id: "a7", type: "company_created", actor: "Rafael Soto", target: "Uncle Giuseppe's Marketplace", time: "Nov 4, 2025", description: "Created company tenant — first paying pilot" },
];

export const STATUS_META = {
  active: { label: "Active", tone: "emerald" },
  archived: { label: "Archived", tone: "slate" },
  inactive: { label: "Inactive", tone: "slate" },
  deactivated: { label: "Deactivated", tone: "slate" },
  onboarding: { label: "Onboarding", tone: "amber" },
  pending: { label: "Pending", tone: "slate" },
  trial: { label: "Trial", tone: "sky" },
  not_set: { label: "Not set", tone: "slate" },
  synced: { label: "Synced", tone: "emerald" },
  review: { label: "Needs review", tone: "amber" },
  not_started: { label: "Not started", tone: "slate" },
  invited: { label: "Invited", tone: "sky" },
  mapped: { label: "Mapped", tone: "emerald" },
  unmapped: { label: "Unmapped", tone: "rose" },
  complete: { label: "Complete", tone: "emerald" },
  in_review: { label: "In review", tone: "amber" },
};
